import { render, staticRenderFns } from "./viewerBIMEditor.vue?vue&type=template&id=4321a812&scoped=true"
import script from "./viewerBIMEditor.vue?vue&type=script&lang=js"
export * from "./viewerBIMEditor.vue?vue&type=script&lang=js"
import style0 from "./viewerBIMEditor.vue?vue&type=style&index=0&id=4321a812&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4321a812",
  null
  
)

export default component.exports